//解决ie兼容
import 'babel-polyfill'
if (Number.parseInt === undefined) Number.parseInt = window.parseInt;
if (Number.parseFloat === undefined) Number.parseFloat = window.parseFloat;

import Vue from 'vue'
import App from './App.vue'
import { router } from './router'
import store from './store/index'
import api from './api'
import utils from './utils/utils'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import checkLogin from './utils/checkLogin'
import signOut from './utils/signOut'
//import VueAMap from 'vue-amap';
import '@/assets/js/art-tool.js'

Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.$utils = utils
Vue.use(ElementUI);

//定义一个直接挂载到Vue上的预览资源方法
import PreSource from '@/components/preSource/index.js'
Vue.prototype.$preSource = PreSource;
Vue.prototype.$checkLogin = checkLogin
Vue.prototype.$signOut = signOut

/*
//定义一个公共组件（无需在页面import的组件，任何页面可以直接使用）
//方法1：
import Com from '@/components/com/Com.vue'
Vue.component('Com',Com); //(组件的名字取决于这里'Com')
//方法2：
import Com from '@/components/com/index.js'
Vue.use(Com); //(组件的名字取决于组件中定义的name)
*/

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
